/**
 * @flow
 * @relayHash 0f76346f7470d2d996cc2f157559cfe0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type cancelRsvpInput = {|
  clientMutationId?: ?string,
  eventId: string,
  id: string,
  reason?: ?string,
|};
export type cancelRsvpMutationVariables = {|
  input: cancelRsvpInput
|};
export type cancelRsvpMutationResponse = {|
  +cancelRsvp: ?{|
    +attendee: ?{|
      +id: string
    |}
  |}
|};
export type cancelRsvpMutation = {|
  variables: cancelRsvpMutationVariables,
  response: cancelRsvpMutationResponse,
|};
*/


/*
mutation cancelRsvpMutation(
  $input: cancelRsvpInput!
) {
  cancelRsvp(input: $input) {
    attendee {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "cancelRsvpInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "cancelRsvp",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "cancelRsvpPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "attendee",
        "storageKey": null,
        "args": null,
        "concreteType": "Attendee",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "cancelRsvpMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "cancelRsvpMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "cancelRsvpMutation",
    "id": null,
    "text": "mutation cancelRsvpMutation(\n  $input: cancelRsvpInput!\n) {\n  cancelRsvp(input: $input) {\n    attendee {\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3aba1519d3e623bc90881c8db842abaf';
module.exports = node;
